<template>
	<div class="">
		<div class="w-full bg-white h-[74px]">
			<examHeader :title="title"></examHeader>
			<div v-if="isFinish" class="2xl:w-[1200px] xl:w-[1200px] lg:w-[1000px] mx-auto flex justify-between">
				<div
					class="lg:w-[700px] 2xl:w-[900px] xl:w-[900px]   h-[78vh]  mr-[10px] flex flex-col overflow-hidden">
					<div v-loading="loading" :style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}"
						class="w-full max-h-[100%]  min-h-[50%] overflow-y-auto bg-repeat  shadow-01 rounded-[6px] mb-[10px] bg-white py-[30px] px-[16px] box-border">
						<div class="mb-[42px]">
							<div v-if="current_question_type=='case'"
								class="answerSheetTitle bB-01  p-[16px] box-border relative text-[16px] text-[#1B2128] font-bold">
								【{{langInfo['Case description']}}】
							</div>

							<div v-if="current_question_type=='case'"
								class="pt-[16px] px-[13px] mb-[20px] box-border relative" style="line-height: 1.6;">
								<label v-html="caseTopicInfo.content"></label>
							</div>
							<div class="flex  mb-[20px]">
								<el-tooltip class="item" effect="dark"
									:content="currentTopicInfo.is_user_collection==1?langInfo['cancel_collect']:langInfo['click_collect']"
									placement="bottom">
									<img @click="collectClick()"
										:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
										class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								</el-tooltip>
								<img @click="questionClick()"
									:src="currentTopicInfo.is_user_question==1?questionActive:questionImg"
									class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />

								<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">

									<label
										v-if="type=='collect'||type=='userwrong'">{{(data_current_page - 1 ) * 20 + currentTopic +1}}.</label>

									<label v-else-if="type=='sele'">{{currentTopic + 1 }}.</label>

									<span v-html="currentTopicInfo.content" class="whitespace-pre-wrap"></span>
								</div>
							</div>


							<div class="pl-[68px] box-border text-[#101010]" v-if="currentTopicInfo.question_type==3">
								<!-- 判断题传 1对0错 -->
								<div @click="selectJudgmentClick('1')"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentTopicInfo.isJudgmentSelect=='1'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['right']}}</label>
								</div>
								<div @click="selectJudgmentClick('0')"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentTopicInfo.isJudgmentSelect=='0'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['wrong']}}</label>
								</div>
							</div>

							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==1">
								<div @click="selectClick(item,index)" v-for="(item,index) in optionsList"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="item.isSelect?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{item.key}}.</label><label
										class="cursor-pointer" v-html="item.value"></label>
								</div>
							</div>

							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==5">
								<textarea maxlength="200" class="w-[100%] h-[160px]"
									v-model="currentTopicInfo.shortContent"></textarea>

								<div class="flex justify-end">
									<div @click="saveShortTopic()"
										class="min-w-[100px] px-[10px] box-border bg-[#2979FF] h-[28px] leading-[28px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
										{{langInfo['save_btn']}}
									</div>
								</div>
							</div>
						</div>

						<div class="flex mb-[20px]">
							<div @click="currentTopicInfo.isShowAnswer=!currentTopicInfo.isShowAnswer"
								class="min-w-[100px] px-[10px] bg-[#2979FF] box-border h-[34px] leading-[34px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
								<i class="el-icon-postcard"></i> {{langInfo['answer']}}
							</div>
						</div>



						<div v-if="currentTopicInfo.isShowAnswer"
							class="bg-[#F5F5F5] p-[22px] box-border mb-[18px] relative" style="z-index: 0;">
							<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
								<label v-if="currentTopicInfo.question_type==1||currentTopicInfo.question_type==3"
									class="min-w-[80px]">{{langInfo.study_paper_answer_standard}}：</label>
								<label v-if="currentTopicInfo.question_type==1">{{currentTopicInfo.answer}}</label>
								<label
									v-else-if="currentTopicInfo.question_type==3">{{currentTopicInfo.answer=='1'?langInfo['right']:langInfo['wrong']}}</label>
							</div>
							<div class=" text-[16px]  text-[#101010] flex ">
								<label class="font-semibold min-w-[80px] flex justify-between">
									{{langInfo.study_paper_answer_tip}}：</label>
								<div v-html="currentTopicInfo.analysis"
									class="flex-1 text-[#101010] whitespace-pre-wrap">
								</div>
							</div>
						</div>
					</div>

					<div v-if="type=='collect'||type=='userwrong'"
						class="shadow-01 rounded-[6px] h-[56px] bg-white flex items-center justify-center">
						<div @click="preTopic()"
							:class="((data_current_page - 1 ) * 20 + currentTopic +1)==1?'bg-[#8FC3FF]':'bg-[#2979FF] '"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_pre}}
						</div>
						<div @click="nextTopic()"
							:class="((data_current_page - 1 ) * 20 + currentTopic +1)==data_log_all?'bg-[#8FC3FF]':'bg-[#2979FF]'"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center  text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_next}}
						</div>
					</div>

					<div v-else-if="type=='sele'"
						class="shadow-01 rounded-[6px] h-[56px] bg-white flex items-center justify-center">
						<div @click="preTopic()" :class="currentNumber==1?'bg-[#8FC3FF]':'bg-[#2979FF] '"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_pre}}
						</div>
						<div @click="nextTopic()" :class="currentNumber==totalnum?'bg-[#8FC3FF]':'bg-[#2979FF]'"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_next}}
						</div>
					</div>
				</div>
				<div class="flex-1">
					<div class="h-[68vh]  pb-[24px] box-border flex flex-col shadow-01 rounded-[6px]  bg-white">
						<div
							class="answerSheetTitle bB-01  p-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
							{{langInfo.study_paper_card}}
						</div>
						<div v-if="type=='collect'||type=='userwrong'"
							class="flex flex-wrap overflow-y-auto  mb-[20px] py-[20px] px-[13px] box-border ">
							<div @click="selectTopic(item,index)"
								:class="[ item.userrecord && item.userrecord.user_answer?'bg-[#ff9000] text-white':'', currentTopic==index?'bg-[#A6A6A6] text-white':'']"
								class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
								v-for="(item,index) in topicList" :key="index">
								<img v-if="item.is_user_question==1&&item.is_user_collection==1"
									src="@/static/image/icon55.png"
									class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt="" srcset="" />
								<img v-else-if="item.is_user_question==1" src="@/static/image/icon55.png"
									class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt="" srcset="" />

								<img v-if="item.is_user_collection==1" :src="collectActive"
									class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]" alt=""
									srcset="" />
								<label class="cursor-pointer">{{(data_current_page - 1 ) * 20 + index +1}}</label>
							</div>
						</div>

						<div class=" mb-[20px]" v-else>
							<div v-if="seleList[0].length>0"
								class="flex flex-wrap overflow-y-auto   py-[20px] px-[13px] box-border">
								<div @click="selectTopic(item,index,'single')"
									:class="[ item.userrecord && item.userrecord.user_answer?'bg-[#ff9000] text-white':'',  current_question_type=='single'&&currentTopic==index?'bg-[#A6A6A6] text-white':'']"
									class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
									v-for="(item,index) in seleList[0]" :key="index">
									<img v-if="item.is_user_question==1&&item.is_user_collection==1"
										src="@/static/image/icon55.png"
										class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt="" srcset="" />
									<img v-else-if="item.is_user_question==1" src="@/static/image/icon55.png"
										class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt="" srcset="" />

									<img v-if="item.is_user_collection==1" :src="collectActive"
										class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]"
										alt="" srcset="" />
									<label class="cursor-pointer"> {{index + 1 }}</label>
								</div>
							</div>
							<div class="" v-if="seleList[1].length>0">
								<div class="" v-for="(item,index) in seleList[1]" :key="index">
									<div class="px-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
										{{langInfo['case']}} {{index+1}}
									</div>
									<div class="flex flex-wrap overflow-y-auto   py-[16px] px-[13px] box-border ">
										<div @click="selectCaseTopic(item,index,iteClass,indeClass ,'case')"
											:class="[ iteClass.userrecord && (iteClass.userrecord.user_answer || iteClass.userrecord.user_answer==='0')?'bg-[#ff9000] text-white':'', current_question_type=='case'&& currentTopic==indeClass &&caseIndex==index?'bg-[#A6A6A6] text-white':'']"
											class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
											v-for="(iteClass,indeClass) in item.class" :key="indeClass">
											<img v-if="iteClass.is_user_question==1&&iteClass.is_user_collection==1"
												src="@/static/image/icon55.png"
												class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt=""
												srcset="" />
											<img v-else-if="iteClass.is_user_question==1"
												src="@/static/image/icon55.png"
												class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt=""
												srcset="" />

											<img v-if="iteClass.is_user_collection==1" :src="collectActive"
												class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]"
												alt="" srcset="" />
											<label class="cursor-pointer"> {{indeClass + 1 }}</label>
										</div>
									</div>
								</div>
							</div>

						</div>


						<div class="flex items-center justify-center mt-[14px] mb-[20px]"
							v-if="type == 'collect' || type == 'userwrong'">
							<div @click="prePaperCard()" :class="data_current_page==1?'bg-[#8FC3FF]':'bg-[#2979FF] '"
								class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
								{{langInfo.study_paper_answer_pre}}
							</div>
							<div @click="nextPaperCard()"
								:class="total_page==data_current_page?'bg-[#8FC3FF]':'bg-[#2979FF]'"
								class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-white text-[14px] rounded-[6px] cursor-pointer">
								{{langInfo.study_paper_answer_next}}
							</div>
						</div>


						<div @click="handPaper()"
							class="bg-[#2979FF] w-[227px] h-[40px] leading-[40px] mx-auto text-center text-white rounded-[6px] cursor-pointer">
							{{langInfo['Submit exercises']}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Number } from 'core-js'
	import examHeader from '@/components/examHeader.vue'
	export default {
		components: {

			examHeader
		},
		data() {
			return {
				title: '',

				selectImg: require('@/static/image/icon37.png'),
				selectedImg: require('@/static/image/icon38.png'),


				collectActive: require('@/static/image/icon22Active.png'),
				collectImg: require('@/static/image/icon22.png'),

				questionActive: require('@/static/image/icon36Active.png'),
				questionImg: require('@/static/image/icon36.png'),

				optionsList: [],

				// 当前题
				currentTopic: 0,
				currentTopicInfo: {
					id: '',
					title: '',
					isCollect: false,
					isQuestion: false,
					isShowAnswer: false,
					shortContent: '',
					isJudgmentSelect: '',


				},
				// 题列表
				topicList: [],
				small_id: '',
				type: '',
				identification: '',
				type: '', //sele章节练习  userwrong错题练习  collect收藏练习
				order_item_id: '',
				langInfo: {},

				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username + '@' + this.$common
					.currentTime() + '@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,

				answeredNum: 0,

				isFinish: false,

				seleList: [
					[],
					[]
				],
				current_question_type: 'single',
				caseIndex: 0,
				caseTopicInfo: {},

				currentNumber: 0,

				totalnum: 0,



				data_log_all: 0,
				data_log_limit: 0,
				data_log_page: 1,

				data_current_page: 1,

				total_page: 1,

				order: 1, //1正序  2倒序 
				now_done_question_count: 0,

				otherPageNum: 0,
				loading: false

			}
		},
		mounted() {

			this.small_id = this.$route.query.small_id
			this.type = this.$route.query.type
			this.identification = this.$route.query.identification
			this.order_item_id = this.$route.query.order_item_id


			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}


			if (this.type == 'sele') {
				this.getQuestionInfo()
			} else if (this.type == 'collect' || this.type == 'userwrong') {
				this.getQuestionLog()
			}



			this.currentTopic = Number(localStorage.getItem('currentTopic'))

		},
		destroyed() {
			console.log("销毁")
			console.log("销毁===========");
			localStorage.removeItem('currentTopic')
		},
		methods: {
			getAnsweredNum() {

				if (this.type == 'sele') {

					let num = 0

					this.seleList[0].forEach((itm, ind) => {
						if (itm.userrecord && itm.userrecord.user_answer) {
							num++
						}
					})

					this.seleList[1].forEach((itm, ind) => {
						itm.class.forEach((it, inx) => {
							if (it.userrecord && it.userrecord.user_answer) {
								num++
							}
						})

					})
					this.answeredNum = num



				} else {
					let num = 0
					this.topicList.forEach((itm, ind) => {
						if (itm.userrecord && itm.userrecord.user_answer) {
							num++
						}
					})

					this.answeredNum = this.otherPageNum + Number(num)
				}

				console.log("this.answeredNum===" + this.answeredNum);
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},

			getQuestionLog() {

				this.$api.getQuestionLog({
					small_id: this.small_id,
					type: this.type,
					identification: this.identification,
					order_item_id: this.order_item_id
				}).then((res) => {
					console.log(res.data);

					this.data_log_all = res.data.data_log_all
					this.data_log_limit = res.data.data_log_limit
					this.data_log_page = res.data.data_log_page

					this.data_current_page = res.data.data_log_page


					this.total_page = Math.ceil(this.data_log_all / 20)

					this.currentTopic = 0

					console.log("@121");

					this.getQuestionInfo()

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},

			getQuestionInfo() {

				let param = {

					small_id: this.small_id,
					type: this.type,
					identification: this.identification,
					order_item_id: this.order_item_id

				}

				if (this.type == 'collect' || this.type == 'userwrong') {
					param.page = this.data_log_page
				}

				console.log('湖区哦==');



				this.$api.getQuestionPaper(param).then((res) => {
					console.log("res==");
					console.log(res);
					document.title = this.title
					this.questionInfo = res.data



					if (this.type == 'sele') {
						this.title = res.data.chapter_name + '-' + this.langInfo.study_exercise_chapter
					} else if (this.type == 'collect') {
						this.title = res.data.chapter_name + '-' + this.langInfo.study_collect_start
					} else if (this.type == 'userwrong') {
						this.title = res.data.chapter_name + '-' + this.langInfo.study_wrong_start
					}


					if (this.type == 'collect' || this.type == 'userwrong') {
						// is_user_collection=是否收藏0否1是
						res.data.data.forEach((item, index) => {
							item.options.forEach((itm, ind) => {
								this.$set(itm, 'isSelect', false)
							})

							if (item.question_type == 5) {
								this.$set(item, 'shortContent', '')
							} else if (item.question_type == 3) {
								this.$set(item, 'isJudgmentSelect', -1)
							}

						})
						this.topicList = res.data.data



						this.data_current_page = parseInt(res.data.input_page)

						this.now_done_question_count = parseInt(res.data.now_done_question_count)

						this.answeredNum = this.now_done_question_count

						let num = 0

						this.topicList.forEach((itm, ind) => {

							if (itm.userrecord && itm.userrecord.user_answer) {
								num++
							}
						})

						this.otherPageNum = this.now_done_question_count - parseInt(num)



						if (this.type == 'collect') {
							this.totalnum = res.data.user_collection_count
						} else if (this.type == 'userwrong') {
							this.totalnum = res.data.question_userwrong_count
						}


						if (this.order == 2) {
							this.currentTopic = this.topicList.length - 1
						} else {
							this.currentTopic = 0
						}


					} else {

						this.seleList = res.data.data
						let total = 0
						for (let j = 0; j < this.seleList[1].length; j++) {
							let itm = this.seleList[1][j];

							total = total + itm.class.length

						}
						this.totalnum = this.seleList[0].length + total


						this.seleList[1].forEach((item, index) => {
							item.class.forEach((itm, ind) => {
								itm.options.forEach((it, index_c) => {
									this.$set(it, 'isSelect', false)
								})
								if (itm.question_type == 5) {
									this.$set(itm, 'shortContent', '')
								} else if (itm.question_type == 3) {
									this.$set(item, 'isJudgmentSelect', -1)
								}
							})
						})


						if (this.seleList[0].length == 0) {
							this.current_question_type = 'case'
						} else {
							this.current_question_type = 'single'
						}
					}

					this.isFinish = true






					this.getCurrentInfo()


				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			getCurrentNumber() {
				console.log("34343");
				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {
						this.currentNumber = this.currentTopic + 1
					} else if (this.current_question_type == 'case') {

						let tpIndex = 0
						let isExit = false

						for (let j = 0; j < this.seleList[1].length; j++) {
							let itm = this.seleList[1][j];

							if (isExit == true) {
								break
							}
							for (let d = 0; d < itm.class.length; d++) {
								if (this.caseIndex == j && this.currentTopic == d) {
									isExit = true
									break;
								}
								tpIndex++
							}
						}
						this.currentNumber = this.seleList[0].length + tpIndex + 1
					}
				} else {
					this.currentNumber = this.currentTopic + 1
				}
			},
			getCurrentInfo() {
				console.log('$34343');
				console.log("this.current_question_type==");
				console.log(this.current_question_type);
				this.loading = false

				this.optionsList = []
				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {

						this.currentTopicInfo = this.seleList[0][this.currentTopic];
						let userrecord = this.seleList[0][this.currentTopic].userrecord

					
						if (this.currentTopicInfo.question_type == 1) {
							this.optionsList = this.currentTopicInfo.options;
							if (userrecord) {
								this.optionsList.forEach((item, index) => {
									this.$set(item, 'isSelect', false)
									if (userrecord.user_answer == item.key) {
										item.isSelect = true
									} else {
										item.isSelect = false
									}
								})
							} else {
								this.optionsList.forEach((item, index) => {
									this.$set(item, 'isSelect', false)
								})
							}
						} else if (this.currentTopicInfo.question_type == 3) {
							if (userrecord) {
								this.currentTopicInfo.isJudgmentSelect = userrecord.user_answer
							} else {
								this.currentTopicInfo.isJudgmentSelect = -1
							}
						}



					} else if (this.current_question_type == 'case') {
						console.log("this.caseIndex==" + this.caseIndex);
						this.caseTopicInfo = this.seleList[1][this.caseIndex]

						console.log("this.currentTopicInfo==")
						console.log(this.caseTopicInfo);


						this.currentTopicInfo = this.seleList[1][this.caseIndex].class[this.currentTopic];

						let userrecord = this.currentTopicInfo.userrecord

						if (this.currentTopicInfo.question_type == 1) {
							this.optionsList = this.currentTopicInfo.options;
							if (userrecord) {
								this.optionsList.forEach((item, index) => {
									this.$set(item, 'isSelect', false)
									if (userrecord.user_answer == item.key) {
										item.isSelect = true
									} else {
										item.isSelect = false
									}
								})
							} else {
								this.optionsList.forEach((item, index) => {
									this.$set(item, 'isSelect', false)
								})
							}
						} else if (this.currentTopicInfo.question_type == 3) {
							if (userrecord) {
								this.currentTopicInfo.isJudgmentSelect = userrecord.user_answer
							} else {
								this.currentTopicInfo.isJudgmentSelect = -1
							}
						} else if (this.currentTopicInfo.question_type == 5) {
							if (userrecord) {
								this.currentTopicInfo.shortContent = userrecord.user_answer
							} else {
								this.currentTopicInfo.shortContent = ''
							}
						}



					}

					this.$set(this.currentTopicInfo, 'isShowAnswer', false)

					this.currentTopicInfo.content = this.decodeHtml(this.currentTopicInfo.content)



				} else {
					this.optionsList = []
					this.currentTopicInfo = this.topicList[this.currentTopic];

					let userrecord = this.topicList[this.currentTopic].userrecord


					if (this.currentTopicInfo.question_type == 1) {
						this.optionsList = this.currentTopicInfo.options;
						if (userrecord) {
							this.optionsList.forEach((item, index) => {
								this.$set(item, 'isSelect', false)
								if (userrecord.user_answer == item.key) {
									item.isSelect = true
								} else {
									item.isSelect = false
								}
							})
						} else {
							this.optionsList.forEach((item, index) => {
								this.$set(item, 'isSelect', false)
							})
						}
					} else if (this.currentTopicInfo.question_type == 3) {
						if (userrecord) {
							this.currentTopicInfo.isJudgmentSelect = userrecord.user_answer
						} else {
							this.currentTopicInfo.isJudgmentSelect = -1
						}
					}


					this.$set(this.currentTopicInfo, 'isShowAnswer', false)

					this.currentTopicInfo.content = this.decodeHtml(this.currentTopicInfo.content)

				}




				this.getCurrentNumber()
				this.get_user_log()
				this.getAnsweredNum()
			},

			decodeHtml(html) {
				if (!html) return ''

				const textarea = document.createElement('textarea')
				textarea.innerHTML = html

				return textarea.value
			},

			prePaperCard() {
				this.loading = true
				this.order = 1
				this.changePre()
			},
			nextPaperCard() {
				this.loading = true
				this.order = 1
				this.changeNext()
			},

			// type: '', //sele章节练习  userwrong错题练习  collect收藏练习

			get_user_log() {

				let logoType = 3
				if (this.type == 'collect') {
					logoType = 5
				} else if (this.type == 'userwrong') {
					logoType = 4
				}

				this.$api.user_log({
					action: 'question',
					type: logoType, // type 类型:3章节练习,4=错题练习,5=收藏练习
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},


			// 保存简答题
			saveShortTopic() {

				let mode = 1;
				if (this.type == 'userwrong') {
					mode = 2
				}


				let course_question_id = ''

				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {
						course_question_id = this.seleList[0][this.currentTopic].id

						if (this.seleList[0][this.currentTopic].userrecord) {
							this.seleList[0][this.currentTopic].userrecord.user_answer = this.currentTopicInfo.shortContent
						} else {
							this.seleList[0][this.currentTopic].userrecord = {}
							this.seleList[0][this.currentTopic].userrecord.user_answer = this.currentTopicInfo.shortContent
						}

					} else if (this.current_question_type == 'case') {
						course_question_id = this.seleList[1][this.caseIndex].class[this.currentTopic].id;


						if (this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord) {
							this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord.user_answer = this
								.currentTopicInfo.shortContent
						} else {
							this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord = {}
							this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord.user_answer = this
								.currentTopicInfo.shortContent
						}
					}
					this.currentTopicInfo.isJudgmentSelect = this.currentTopicInfo.shortContent

				} else {
					course_question_id = this.topicList[this.currentTopic].id
					if (this.topicList[this.currentTopic].userrecord) {
						this.topicList[this.currentTopic].userrecord.user_answer = this.currentTopicInfo.shortContent
					} else {
						this.topicList[this.currentTopic].userrecord = {}

						this.topicList[this.currentTopic].userrecord.user_answer = this.currentTopicInfo.shortContent
					}
				}




				this.getAnsweredNum()


				this.$api.recordQuestion({
					course_question_id: course_question_id,
					user_answer: this.currentTopicInfo.shortContent,
					mode: mode,
					identification: this.identification
				}).then((res) => {
					console.log(res);

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})


			},

			// 判断题
			selectJudgmentClick(answer) {


				// question_paper_id=试卷id
				// course_question_id=题目id
				// user_answer=用户答案
				// mode=模式 模式:1=练习,2=错题,3=模拟考试
				// identification=试卷标识

				let mode = 1;
				if (this.type == 'userwrong') {
					mode = 2
				}

				let course_question_id = ''

				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {
						course_question_id = this.seleList[0][this.currentTopic].id

						if (this.seleList[0][this.currentTopic].userrecord) {
							this.seleList[0][this.currentTopic].userrecord.user_answer = answer
						} else {
							this.seleList[0][this.currentTopic].userrecord = {}
							this.seleList[0][this.currentTopic].userrecord.user_answer = answer
						}

					} else if (this.current_question_type == 'case') {
						course_question_id = this.seleList[1][this.caseIndex].class[this.currentTopic].id;


						if (this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord) {
							this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord.user_answer = answer
						} else {
							this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord = {}
							this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord.user_answer = answer
						}
					}


				} else {
					course_question_id = this.topicList[this.currentTopic].id
					if (this.topicList[this.currentTopic].userrecord) {
						this.topicList[this.currentTopic].userrecord.user_answer = answer
					} else {
						this.topicList[this.currentTopic].userrecord = {}

						this.topicList[this.currentTopic].userrecord.user_answer = answer
					}


				}
				this.currentTopicInfo.isJudgmentSelect = answer





				this.getAnsweredNum()


				this.$api.recordQuestion({
					course_question_id: course_question_id,
					user_answer: answer,
					mode: mode,
					identification: this.identification
				}).then((res) => {
					console.log(res);

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})


			},


			selectClick(item, index) {


				this.optionsList.forEach((itm, ind) => {
					if (index == ind) {
						console.log("item.isSelect==");
						console.log(item.isSelect);
						itm.isSelect = !itm.isSelect
					} else {
						itm.isSelect = false
					}
				})

				// question_paper_id=试卷id
				// course_question_id=题目id
				// user_answer=用户答案
				// mode=模式 模式:1=练习,2=错题,3=模拟考试
				// identification=试卷标识

				let mode = 1;
				if (this.type == 'userwrong') {
					mode = 2
				}

				let course_question_id = ''

				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {
						course_question_id = this.seleList[0][this.currentTopic].id

						if (this.seleList[0][this.currentTopic].userrecord) {
							this.seleList[0][this.currentTopic].userrecord.user_answer = item.isSelect ? item.key : ''
						} else {
							this.seleList[0][this.currentTopic].userrecord = {}
							this.seleList[0][this.currentTopic].userrecord.user_answer = item.isSelect ? item.key : ''
						}

					} else if (this.current_question_type == 'case') {
						course_question_id = this.seleList[1][this.caseIndex].class[this.currentTopic].id;


						if (this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord) {
							this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord.user_answer = item
								.isSelect ? item.key : ''
						} else {
							this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord = {}
							this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord.user_answer = item
								.isSelect ? item.key : ''
						}


					}
				} else {
					course_question_id = this.topicList[this.currentTopic].id
					if (this.topicList[this.currentTopic].userrecord) {
						this.topicList[this.currentTopic].userrecord.user_answer = item.isSelect ? item.key : ''
					} else {
						this.topicList[this.currentTopic].userrecord = {}

						this.topicList[this.currentTopic].userrecord.user_answer = item.isSelect ? item.key : ''
					}
				}

				this.getAnsweredNum()


				this.$api.recordQuestion({
					course_question_id: course_question_id,
					user_answer: item.isSelect ? item.key : '',
					mode: mode,
					identification: this.identification
				}).then((res) => {
					console.log(res);

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			// 上一页
			preTopic() {


				if (this.type == 'sele') {

					if (this.currentNumber == 1) {
						return
					}

					if (this.current_question_type == 'single') {
						this.currentTopic--;

						this.getCurrentInfo()

					} else if (this.current_question_type == 'case') {

						if (this.caseIndex == 0 && this.currentTopic == 0) {

							this.current_question_type = 'single'
							this.currentTopic = this.seleList[0].length - 1
							this.getCurrentInfo()
							return
						}

						if (this.caseIndex > 0 && this.currentTopic == 0) {
							this.caseIndex--;
							this.currentTopic = this.seleList[1][this.caseIndex].class.length - 1;
							this.getCurrentInfo()
							return
						}
						this.currentTopic--
						this.getCurrentInfo()

					}


				} else {

					this.loading = true
					if (this.currentTopic == 0) {
						this.order = 2
						this.changePre()
						return
					}
					this.currentTopic--;
					this.order = 2

					this.getCurrentInfo()
				}


			},

			changePre() {
				this.data_log_page = this.data_current_page
				if (this.data_log_page == 1) {
					this.loading = false
					return
				}
				this.data_log_page--;
				this.getQuestionInfo()
			},
			nextTopic() {

				if (this.type == 'sele') {

					if (this.currentNumber == this.totalnum) {
						return
					}

					if (this.current_question_type == 'single') {
						if (this.currentTopic == this.seleList[0].length - 1) {
							this.current_question_type = 'case'
							this.caseIndex = 0;
							this.currentTopic = 0
							this.getCurrentInfo()
							return
						}
						this.currentTopic++
						this.getCurrentInfo()
					} else if (this.current_question_type == 'case') {
						if (this.currentTopic + 1 == this.seleList[1][this.caseIndex].class.length) {
							if (this.caseIndex + 1 == this.seleList[1][this.caseIndex].length) {
								return
							}

							this.caseIndex++;
							this.currentTopic = 0
							this.getCurrentInfo()
							return
						}

						this.currentTopic++
						this.getCurrentInfo()

					}
				} else {

					this.loading = true
					if ((this.currentTopic + 1) == this.topicList.length) {
						this.order = 1
						this.changeNext()
						return
					}


					this.order = 1
					this.currentTopic++
					this.getCurrentInfo()
				}

			},

			changeNext() {
				this.data_log_page = this.data_current_page
				if (this.total_page == this.data_log_page) {
					this.loading = false
					return
				}
				this.data_log_page++;
				this.getQuestionInfo()
			},

			selectTopic(item, index, type) {
				this.caseTopicInfo = {}
				this.current_question_type = type
				this.currentTopic = index;

				this.getCurrentInfo()
			},

			selectCaseTopic(item, index, iteClass, indeClass, type) {
				this.caseTopicInfo = item
				this.current_question_type = type
				this.currentTopic = indeClass;
				this.caseIndex = index
				this.getCurrentInfo()

			},
			// 收藏
			collectClick() {

				if (this.currentTopicInfo.is_user_collection == 1) {
					this.currentTopicInfo.is_user_collection = 0
				} else {
					this.currentTopicInfo.is_user_collection = 1
				}

				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {

						this.seleList[0][this.currentTopic].is_user_collection = this.currentTopicInfo.is_user_collection
					} else if (this.current_question_type == 'case') {
						this.seleList[1][this.caseIndex].class[this.currentTopic].is_user_collection = this
							.currentTopicInfo.is_user_collection
					}

				} else {
					this.topicList[this.currentTopic].is_user_collection = this.currentTopicInfo.is_user_collection
				}
				// type=类型:1=课程,2=咨询,3=资源,4=题目
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 4,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 疑问标记
			questionClick() {
				if (this.currentTopicInfo.is_user_question == 1) {
					this.currentTopicInfo.is_user_question = 0
				} else {
					this.currentTopicInfo.is_user_question = 1
				}

				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {

						this.seleList[0][this.currentTopic].is_user_question = this.currentTopicInfo.is_user_question
					} else if (this.current_question_type == 'case') {
						this.seleList[1][this.caseIndex].class[this.currentTopic].is_user_question = this.currentTopicInfo
							.is_user_question
					}

				} else {
					this.topicList[this.currentTopic].is_user_question = this.currentTopicInfo.is_user_question
				}


				// type=类型:1=课程,2=咨询,3=资源,4=题目  5 疑问
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 5,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功、疑问
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			// 提交试卷
			handPaper() {
				let tip = this.langInfo['completed exercise tip']
				if (Number(this.answeredNum) > 0 && Number(this.answeredNum) == Number(this.totalnum)) {
					tip = this.langInfo['completed exercise tip']
				} else {
					tip = this.langInfo.not_completed_exercises
				}
				this.$confirm(tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.updateExamStatus({
						action: 'complete',
						identification: this.identification
					}).then((res) => {
						this.$message({
							message: res.msg,
							type: 'success'
						})
						setTimeout(() => {
							this.$router.push({
								path: '/exam/chapterEnd',
								query: {
									id: res.data.id,
									identification: this.identification,
									type: this.type,
									order_item_id: this.order_item_id
								}
							})
						}, 800)
					}).catch((error) => {

						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})
				}).catch(() => {

				});

			},

		}
	}
</script>

<style scoped>
	/* ::-webkit-scrollbar {
		display: none;
	} */

	.answerSheetTitle::after {
		content: '';
		position: absolute;
		width: 4px;
		height: 21px;
		background-color: rgba(103, 194, 58, 1);
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.topicItem:nth-child(5n) {
		margin-right: 0;

	}

	.topicItem {
		width: 18%;
		height: 30px;
		line-height: 30px;
		margin-right: 2.5%;
		border: 1px solid rgba(187, 187, 187, 1);
	}


	/deep/p img {
		width: 100% !important;
	}
</style>